module.exports = __webpack_public_path__ + "static/dashboard-freemium-7ba15da65e22a30df7af4474c1e6f3a4.png";